// Privacy_tw.js
import React from "react";
import { Link } from "react-router-dom";
import "../Terms.css";

function Privacy() {
  return (
    <div className="terms-page">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/tw" className="brand-link" aria-label="回到首頁">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="privacy-title">
        <article className="generator-card terms-card" aria-labelledby="privacy-title">
          <header className="terms-header">
            <h1 id="privacy-title" className="card-title">TooLoves.net 隱私權政策</h1>
            <p className="card-subtitle terms-updated">
              最後更新：
              <time dateTime="2025-10-22"> 2025年10月22日（KST）</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              本隱私權政策（以下稱「本政策」）說明 TooLoves.net（以下稱「本網站」）如何處理使用者的個人資料。
              使用本網站即表示您同意本政策。
            </p>
          </section>

          <section className="terms-section" id="info-collection">
            <h2 className="section-title">1. 收集的個人資料</h2>
            <p>
              本網站不會直接蒐集可識別個人身分之資訊（例如：姓名、電子郵件、IP 位址等）。
              包含 QR 碼產生、影像浮水印、EXIF 資訊擷取等所有功能，皆在您的裝置端處理；
              影像或資料不會上傳或傳送至伺服器。
            </p>
            <p>
              然而，為了提升服務品質並進行使用狀況分析，本網站使用
              <strong> Google Analytics（GA4）</strong>。Google 可能透過 Cookie 等技術，自動蒐集
              您的存取裝置資訊、瀏覽頁面、停留時間、點擊事件、瀏覽器類型、連線地區（城市層級）等
              <strong> 非個人識別資訊</strong>。這些資料無法用以識別個人，僅用於網站營運與服務改進。
            </p>
          </section>

          <section className="terms-section" id="use-of-info">
            <h2 className="section-title">2. 個人資料的使用目的</h2>
            <p>
              蒐集之資訊僅用於流量分析、錯誤診斷與服務改進等統計目的。
              本網站遵循 Google Analytics（GA4）、Netlify 以及 Google AdSense 的相關政策。
            </p>
          </section>

          <section className="terms-section" id="data-sharing">
            <h2 className="section-title">3. 個人資料的提供與分享</h2>
            <p>
              本網站不會直接蒐集或儲存個人資料。
              但因服務提供所使用的 Netlify、Google AdSense 與 Google Analytics，可能會發生自動資料蒐集。
              這些資料將依各服務提供者的隱私權政策進行管理。
            </p>
          </section>

          <section className="terms-section" id="data-security">
            <h2 className="section-title">4. 個人資料保護</h2>
            <p>
              本網站不自行儲存個人資料；網站運作所需之基礎設施遵循
              <strong> Netlify</strong> 的安全政策。廣告與統計分析則適用
              <strong> Google AdSense</strong> 與 <strong> Google Analytics</strong> 的安全機制。
            </p>
            <p>
              您可透過瀏覽器設定拒絕 Cookie，或安裝
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Analytics（分析）停用瀏覽器外掛程式
              </a>
              以停用資料蒐集。
            </p>
          </section>

          <section className="terms-section" id="policy-changes">
            <h2 className="section-title">5. 政策變更</h2>
            <p>
              我們可能視需要變更本隱私權政策；若有變更，將於網站公告或本頁面通知。
            </p>
            <p>
              變更後您仍持續使用本服務，即視為已同意修訂後之政策。
            </p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">6. 聯絡方式</h2>
            <p>
              服務相關問題請來信
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="傳送電子郵件至 helptooloves@gmail.com"
              >
                helptooloves@gmail.com
              </a>
              。
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/tw" className="btn" aria-label="回到首頁">
              回到首頁
            </Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">
        © 2025 TooLoves. All rights reserved.
      </footer>
    </div>
  );
}

export default Privacy;